export default __webpack_public_path__ + "static/article-real-stories-saving-spending-lending-maddy-b38574a44fb4a8d4a6bd6ddbf4a95432.jpg";